export default __webpack_public_path__ + "static/media/settings.9f7c625e.md";